import { Flag, Globe2, MapPin } from "lucide-react";

const META = {
  local: { icon: MapPin, label: "Local Market", tone: "text-cyan-300" },
  country: { icon: Flag, label: "Country Market", tone: "text-blue-300" },
  global: { icon: Globe2, label: "Global Market", tone: "text-violet-300" },
};

export const GeoMiniCards = ({ geographies = [] }) => (
  <div className="grid grid-cols-1 gap-2 sm:grid-cols-3" data-testid="geo-mini-cards">
    {["local", "country", "global"].map((level) => {
      const g = geographies.find((x) => x.level === level);
      const { icon: Icon, label, tone } = META[level];
      return (
        <div key={level} className="min-w-0 rounded-xl border border-white/[0.08] bg-white/[0.03] p-3" data-testid={`geo-card-${level}`}>
          <div className="flex items-center gap-2">
            <Icon className={`h-4 w-4 shrink-0 ${tone}`} aria-hidden="true" />
            <span className="truncate text-xs font-semibold text-white">{label}</span>
          </div>
          <div className="mt-0.5 truncate text-[10px] text-slate-500">Geographical Score · {g?.region_label ?? "…"}</div>
          <div className="mt-2 flex flex-wrap items-baseline gap-x-1">
            <span className="font-mono text-lg font-bold text-white" data-testid={`geo-card-${level}-score`}>
              {g ? Math.round(g.lens_score * 10) : "--"}/100
            </span>
            <span className="text-[10px] text-slate-400">Confidence</span>
          </div>
          <div className="mt-2 flex flex-wrap gap-1">
            <span className="rounded-full bg-amber-500/10 px-1.5 py-0.5 text-[9px] font-semibold text-amber-300">Method Estimate</span>
            {g?.source_citation && (
              <span className="rounded-full bg-emerald-500/10 px-1.5 py-0.5 text-[9px] font-semibold text-emerald-300" title={`${g.source_citation} (${g.source_date})`}>
                Sourced Fact
              </span>
            )}
          </div>
        </div>
      );
    })}
  </div>
);
